import { PaperPlaneRightIcon } from "@phosphor-icons/react/dist/csr/PaperPlaneRight";
import { Button } from "@volca/ui/components/ui/button";
import { SearchInput } from "@volca/ui/components/ui/search-input";
import { Spinner } from "@volca/ui/components/ui/spinner";
import { Stack } from "@volca/ui/components/ui/stack";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@volca/ui/components/ui/tooltip";
import { isRenotifyOnly } from "@/payroll/pay-breakdown/payroll-statement-notifications/utils";
import { TeamFilter } from "@/payroll/teams/team-filter";
import { usePacksSection } from "./packs-section-provider";

export const PacksHeaderActions = () => {
  const {
    teams,
    teamIds,
    setTeamIds,
    recipients,
    technicianSearch,
    setTechnicianSearch,
    previewOnly,
    sendDisabledReason,
    isSendSubmitting,
    setConfirmSendOpen,
    selectedEligibleRecipients,
  } = usePacksSection();

  const sendButton = (
    <Button
      disabled={isSendSubmitting || previewOnly || !!sendDisabledReason}
      onClick={() => setConfirmSendOpen(true)}
      aria-busy={isSendSubmitting || undefined}
    >
      {isSendSubmitting ? (
        <Spinner data-icon="inline-start" aria-hidden />
      ) : (
        <PaperPlaneRightIcon data-icon="inline-start" />
      )}
      {isRenotifyOnly(selectedEligibleRecipients)
        ? "Renotify"
        : "Publish PayPacks"}
    </Button>
  );

  const sendTooltip = previewOnly
    ? "Complete PayPack email setup through Volca to start sending emails."
    : sendDisabledReason;

  return (
    <Stack
      direction="row"
      align="center"
      justify="end"
      gap={2}
      className="w-full flex-wrap sm:w-auto sm:flex-nowrap"
    >
      <TeamFilter teams={teams} value={teamIds} onChange={setTeamIds} />
      {recipients.length > 0 && (
        <>
          {/* align="stretch" is load-bearing: Stack defaults to items-start, which
          left the search field at its intrinsic width inside this sized
          wrapper and opened a ~30px hole before the send button. */}
          <Stack
            gap={0}
            align="stretch"
            className="min-w-48 flex-1 sm:w-64 sm:flex-none"
          >
            <SearchInput
              value={technicianSearch}
              onChange={setTechnicianSearch}
              placeholder="Search technicians"
              aria-label="Search PayPacks by technician name"
              className="w-full"
            />
          </Stack>
          {sendTooltip ? (
            <Tooltip>
              <TooltipTrigger render={<div />}>{sendButton}</TooltipTrigger>
              <TooltipContent>{sendTooltip}</TooltipContent>
            </Tooltip>
          ) : (
            sendButton
          )}
        </>
      )}
    </Stack>
  );
};
